import React from 'react';
import { useNavigate } from 'react-router-dom';
import WeeklyReportsTable from './components/WeeklyReportsTable';
import PageHeader from '../../Common/PageHeader';
import Breadcrumbs from '../../Common/Breadcrumbs';

const WeeklyReportsPage = () => {
  const navigate = useNavigate();

  const handleAddNew = () => {
    navigate('/WeeklyReports/detail');
  };

  return (
    <div className="container-fluid" style={{ marginTop: '20px' }}>
      <Breadcrumbs
        items={[{ label: 'All Weekly Reports Management', active: true }]}
      />
      <PageHeader
        breadcrumb={null}
        title="Weekly Reports Management"
        addNewLabel="Add New"
        onAddNew={handleAddNew}
      />
      <WeeklyReportsTable />
    </div>
  );
};

export default WeeklyReportsPage; 